/**
 * @author: varun
 * Takes care of angular caching(performance) and all the services associated with the campaigns.
 */

angular.module('AppCtrl.campaign.service', ['AppCtrl.jobvite.service', 'AppCtrl.campaign.constant', 'jv.totango'])
    .constant('TypeLinkMatch', {
        'CAMPAIGN_TYPE_WEB_PAGE': 'webpage',
        'WEBSITE': 'webpage',
        'CAMPAIGN_TYPE_EMAIL': 'email',
        'EMAIL': 'email',
        'CAMPAIGN_TYPE_SOCIAL_MEDIA': 'social',
        'SOCIAL': 'social'
    })
    .value('CONST', {
        debuggingEnabled: true,
        Urls: {
            'campaigns': window.jvUrls.source + '/action/crm/campaigns/list',
            'delete': window.jvUrls.source + '/action/crm/campaigns/delete',
            'clone': window.jvUrls.source + '/action/crm/campaign/detail/clone/',
            'changeStatus': window.jvUrls.source + '/action/crm/campaigns/changeStatus',
            'getClicks': window.jvUrls.source + '/action/crm/campaigns/clicks',
            'addCampaign': window.jvUrls.source + '/action/crm/campaign/detail/',
            'details': window.jvUrls.source + '/action/crm/campaign/detail/',
            'summary': window.jvUrls.source + '/action/crm/campaign/summary/',
            'contactsList': window.jvUrls.source + '/action/crm/campaign/detail/{0}/contacts',
            'saveEmailTemplate': window.jvUrls.source + '/action/crm/campaign/detail/{0}/content/',
            'copyEmailTemplate': window.jvUrls.source + '/action/crm/campaign/{0}/content/{1}/copy',
            'getEmailContents': window.jvUrls.source + '/action/crm/campaign/detail/{0}/contents',
            'messagesList': window.jvUrls.source + '/action/crm/campaign/summary/{0}/messages',
            'messageLinkAnalytics': window.jvUrls.source + '/action/crm/campaign/summary/{0}/messages/{1}',
            //0-campaignEId, 1-contentEid.
            'deleteEmailTemplate': window.jvUrls.source + '/action/crm/campaign/detail/{0}/contentDelete/{1}',
            'removeFromCampaign': window.jvUrls.source + '/action/person/contactList',
            'saveWebpageContents': window.jvUrls.source + '/action/crm/campaign/detail/{0}/content/',
            'socialCampaignAnalytics': window.jvUrls.source + '/action/crm/campaign/summary/{0}/messages',
            'socialAccounts': window.jvUrls.source + '/action/crm/campaign/detail/{0}/accounts',
            'socialFBAccounts': window.jvUrls.source + '/action/crm/campaign/detail/{0}/accounts/fb',
            'saveAccountsPage': window.jvUrls.source + '/action/crm/campaign/detail/{0}/account/',
            'socialMessagesPage': window.jvUrls.source + '/action/crm/campaign/detail/{0}/contents',
            'scheduleCampaign': window.jvUrls.source + '/action/crm/campaign/detail/{0}/contentSend/{1}',
            'sendAccessToken': window.jvUrls.source + '/action/crm/campaign/detail/{0}/account/fb/{1}',
            'republishError': window.jvUrls.source + '/action/crm/campaign/detail/{0}/content/{1}/republish',
            'getContactSources': window.jvUrls.source + '/action/person/contactList',
            'getContactStatuses': window.jvUrls.source + '/action/person/contactList',
            'checkOldCampaigns': window.jvUrls.source + '/action/crm/campaigns/hasOldCampaigns',
            'previewCampaigns': window.jvUrls.source + '/action/crm/campaign/detail/{0}/previewMessage',
            'requisitionFilter': window.jvUrls.jhire + '/action/requisitions/filters',
            'customFieldsList': window.jvUrls.source + '/action/cadmin/contactCustom/'
        }
    })
    .directive('jvFilterDatepicker', function () {
        // link
        function linker(scope, element, attribute, ngModel) {

            $(element).datepicker({
                changeMonth: true,
                changeYear: true,
                maxDate: '0d',
                minDate: '-1y',
                showOn: 'button',
                buttonImageOnly: true,
                buttonImage: '/__assets__/images/blue/icon-calendar.png',
                onSelect: function (time) {
                    scope.$apply(function () {
                        scope[attribute['ngModel']] = time;
                    });
                }
            });
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: linker
        };
    })
    // log service for debugging.
    .factory('logService', ['CONST', function (CONST) {
        return function (message) {
            if (!CONST.debuggingEnabled) {
                return;
            }
            try {
                console.log(message);
            } catch (e) {}
        };
    }])
    .factory('getCacher', ['$cacheFactory', function ($cacheFactory) {
        var _cacheFactory = {};
        /**
         * @param {Object} cacheName: name of the page Cache object.
         * Cachers used on the page are:
         * campaign_info: Details about the campaign.
         * campaign_summary: Summary analytics for the campaign.
         */
        return function (cacheName) {
            if (typeof _cacheFactory[cacheName] === 'undefined') {
                _cacheFactory[cacheName] = $cacheFactory(cacheName);
            }
            return _cacheFactory[cacheName];
        };
    }])
    // remove specific cache entry
    .factory('removeCacheWithKey', ['getCacher', function (getCacher) {
        return function (cacheKeyName) {
            var _cache = getCacher('CAMPAIGN');
            var _results = _cache.get(cacheKeyName);
            if (typeof _results !== 'undefined') {
                _cache.remove(cacheKeyName);
            }
        };
    }])
    // remove Full cache for campaigns.
    .factory('removeAllCache', ['getCacher', function (getCacher) {
        return function () {
            var _cache = getCacher('CAMPAIGN');
            _cache.removeAll();
        };
    }])
    // Campaign service that has all the api's for making modifications to the campaign.
    .factory('campaignService', ['logService', 'makeAjaxCall', '$rootScope', 'CONST', 'getCacher', 'removeCacheWithKey', 'removeAllCache', '$routeParams', '$timeout', '$q', 'jvTotango', '$log',
        function (logService, makeAjaxCall, $rootScope, CONST, getCacher, removeCacheWithKey, removeAllCache, $routeParams, $timeout, $q, jvTotango, $log) {
            var campaignService = {};
            // Used for persisting the filters on the page.
            var _campaignFilterObjects = null;

            /******************************************
             * Get the campaign Grid objects
             ******************************************/
            campaignService.getCampaigns = function (args, callback) {
                callback = (callback || angular.noop);
                // Enhance the property of the filters with the new values.
                if (_campaignFilterObjects == null) {
                    _campaignFilterObjects = args || {};
                } else {
                    for (var property in args) {
                        _campaignFilterObjects[property] = args[property];
                    }
                }
                _campaignFilterObjects.page = (!!args && !!args.page && args.page > 0) ? args.page : 0;
                // ajax url.
                _campaignFilterObjects['url'] = CONST.Urls.campaigns;
                // ajaxtype for google analytics
                _campaignFilterObjects['ajaxtype'] = 'getCampaigns';
                var _getCampaigns = makeAjaxCall(_campaignFilterObjects);
                _getCampaigns.then(function (results) {
                    $rootScope.$broadcast('campaignResults', results.data);
                    callback(results.data);
                    // also trigger the call for getting the clicks.
                    campaignService.getClicks();
                }, function(error){
                    $log.error(error.data);
                });
            };

            /******************************************
             * Get the campaign Grid objects with no broadcast
             ******************************************/
            campaignService.getCampaignsNoBroadcast = function (args, callback) {
                callback = (callback || angular.noop);
                _campaignFilterObjects = args || {};

                _campaignFilterObjects.page = (!!args && !!args.page && args.page > 0) ? args.page : 0;
                _campaignFilterObjects['url'] = CONST.Urls.campaigns;
                _campaignFilterObjects['ajaxtype'] = 'getCampaigns';
                var _getCampaigns = makeAjaxCall(_campaignFilterObjects);
                _getCampaigns.then(function (results) {
                    callback(results.data);
                }, function(error){
                    $log.error(error.data);
                });
            };

            /******************************************
             * Delete a campaign from the grid.
             ******************************************/
            campaignService.performAction = function (args, callback) {
                callback = (callback || angular.noop);
                if (typeof args.eids === 'undefined' || args.action === 'undefined' || args.eids.length === 0) {
                    try {
                        $rootScope.$broadcast('showSelectionMsg');
                    } catch (e) {}
                    return;
                }
                var _campaignActionObject = {};

                switch (args.action) {
                    case 'delete':
                        _campaignActionObject.url = CONST.Urls['delete'];
                        //_campaignActionObject.status = 3;
                        _campaignActionObject.status = 'CLOSED';
                        break;
                    case 'activate':
                        _campaignActionObject.url = CONST.Urls['changeStatus'];
                        //_campaignActionObject.status = 1;
                        _campaignActionObject.status = 'IN_PROGRESS';
                        break;
                    case 'deactivate':
                        _campaignActionObject.url = CONST.Urls['changeStatus'];
                        //_campaignActionObject.status = 0;
                        _campaignActionObject.status = 'PLANNING';
                        break;
                    default:
                        // default case
                }
                // analytics
                _campaignActionObject['ajaxtype'] = args.action;
                _campaignActionObject['requestType'] = 'POST';
                _campaignActionObject.eids = args.eids;
                var _performCampaignAction = makeAjaxCall(_campaignActionObject);
                return _performCampaignAction.then(function (results) {
                    campaignService.getCampaigns();
                }, function(error){
                    $log.error(error.data);
                });
            };

            /******************************************
             * Get the clicks for the campaigns.
             ******************************************/
            campaignService.getClicks = function () {
                var _campaignFilterClicksObject = angular.copy(_campaignFilterObjects);
                _campaignFilterClicksObject['ajaxtype'] = 'getCampaignClicks';
                _campaignFilterClicksObject['url'] = CONST.Urls['getClicks'];
                var _campaignFilterClicksAction = makeAjaxCall(_campaignFilterClicksObject);
                _campaignFilterClicksAction.then(function (results) {
                    $rootScope.$broadcast('campaignClicks', results.data);
                }, function(error){
                    $log.error(error.data);
                });
            };


            /******************************************
             * Service for adding the campaign.
             ******************************************/
            campaignService.addCampaigns = function (args, callback) {
                callback = (callback || angular.noop);
                var _campaignAddFilterObjects = args || {};

                // ajax url.
                _campaignAddFilterObjects['url'] = CONST.Urls.addCampaign;
                // ajaxtype for google analytics
                _campaignAddFilterObjects['ajaxtype'] = 'createCampaign';
                // POST the request.
                _campaignAddFilterObjects['requestType'] = 'POST';

                var _getCampaigns = makeAjaxCall(_campaignAddFilterObjects);
                _getCampaigns.then(function (results) {
                    // If you are saving the campaign then you must remove the cache associated with the campaign detail info.
                    removeCacheWithKey('campaign_info');

                    $rootScope.$broadcast('campaignResults', results.data);
                    jvTotango.track('Engage Campaign - ' + _campaignAddFilterObjects['type'], jvTotango.module.engage);
                    callback(results.data);
                }, function(error){
                    $log.error(error.data);
                });
            };

            /******************************************
             * Get the details about 'this' present Campaign
             ******************************************/
            campaignService.getDetails = function (args, callback) {
                callback = (callback || angular.noop);
                /**
                 * Boradcast the results to all the listeners.
                 * @param {Object} results: returned from the backend for a specific campaign.
                 * @param {Object} callback: callback that needs to be called when the results come back. Most of the listeners will have a listener with the $on, so might not be used.
                 */
                function broadCastCampaignDetailResults(results, callback) {
                    $rootScope.$broadcast('campaignDetailsResults', results.data);
                    callback(results.data);
                }
                // check if the cache has the results.
                var _cache = getCacher('CAMPAIGN');
                var _results = _cache.get('campaign_info');
                var _campaignObject = args || {};
                // TODO: remove this hardcoded value afterwards from the jsp.
                var _campaignId = $routeParams['ceid'] || _campaignObject['ceid'] || window.JV.CAMPAIGNEID;
                // ajax url.
                _campaignObject['url'] = CONST.Urls.details + _campaignId;
                // ajaxtype for google analytics
                _campaignObject['ajaxtype'] = 'campaignDetails';
                // Make a call to the backend and bind the promise with success.
                var _getCampaignDetails = makeAjaxCall(_campaignObject);
                _getCampaignDetails.then(function (results) {
                    // save the result in the cache.
                    _cache.put('campaign_info', results);
                    broadCastCampaignDetailResults(results, callback);
                }, function(error){
                    $log.error(error.data);
                });
            };

            /******************************************
             * Get the summary analytics for this campaign.
             ******************************************/
            campaignService.getSummary = function (args, callback) {
                callback = (callback || angular.noop);

                function broadCastCampaignSummaryResults(results, callback) {
                    // you can either send a callback or listen to the 'campaignSummaryResults' event. 
                    $rootScope.$broadcast('campaignSummaryResults', results.data);
                    callback(results.data);
                }
                var _campaignObject = args || {};
                var _campaignId = $routeParams['ceid'] || _campaignObject['ceid'] || window.JV.CAMPAIGNEID;
                // ajax url.
                _campaignObject['url'] = CONST.Urls.summary + _campaignId;
                // ajaxtype for google analytics
                _campaignObject['ajaxtype'] = 'campaignSummary';
                // Make a call to the backend and bind the promise with success.
                var _getCampaignSummary = makeAjaxCall(_campaignObject);
                _getCampaignSummary.then(function (results) {
                    broadCastCampaignSummaryResults(results, callback);
                }, function(error){
                    $log.error(error.data);
                });
            };


            /******************************************
             * Get the summary message analytics for this campaign.
             ******************************************/
            campaignService.getMessageSummary = function (args, callback) {
                callback = (callback || angular.noop);

                function broadCastCampaignMessageSummaryResults(results, callback) {
                    // you can either send a callback or listen to the 'campaignSummaryResults' event.
                    $rootScope.$broadcast('campaignMessageSummaryResults', results.data);
                    callback(results.data);
                }
                var _campaignObject = args || {};
                var _campaignId = $routeParams['ceid'] || _campaignObject['ceid'] || window.JV.CAMPAIGNEID;
                // ajax url.
                _campaignObject['url'] = CONST.Urls.messagesList.format(_campaignId);
                // ajaxtype for google analytics
                _campaignObject['ajaxtype'] = 'campaignMessageAnalyticsSummary';
                // Make a call to the backend and bind the promise with success.
                var _getCampaignMessageSummary = makeAjaxCall(_campaignObject);
                _getCampaignMessageSummary.then(function (results) {
                    // save the result in the cache.
                    //_cache.put('campaign_message_summary', results);
                    broadCastCampaignMessageSummaryResults(results, callback);
                }, function(error){
                    $log.error(error.data);
                });
            };

            /******************************************
             * Get the summary message analytics for this campaign.
             ******************************************/
            campaignService.getMessageLinkSummary = function (args, callback) {
                callback = (callback || angular.noop);

                function broadCastCampaignMessageLinkResults(results, callback) {
                    // you can either send a callback or listen to the 'campaignSummaryResults' event.
                    $rootScope.$broadcast('campaignMessageLinkResults', results.data);
                    callback(results.data);
                }
                var _campaignObject = args || {};
                var _campaignId = $routeParams['ceid'] || _campaignObject['ceid'] || window.JV.CAMPAIGNEID;
                // ajax url.
                _campaignObject['url'] = CONST.Urls.messageLinkAnalytics.format(_campaignId, args.messageId);
                delete args.messageId;
                // ajaxtype for google analytics
                _campaignObject['ajaxtype'] = 'campaignMessageAnalyticsSummary';
                // Make a call to the backend and bind the promise with success.
                var _getCampaignLinkSummary = makeAjaxCall(_campaignObject);
                _getCampaignLinkSummary.then(function (results) {
                    // save the result in the cache.
                    //_cache.put('campaign_message_summary', results);
                    broadCastCampaignMessageLinkResults(results, callback);
                }, function(error){
                    $log.error(error.data);
                });
            };

            /*************************************************************
             * Get the contacts of this campaign.
             *************************************************************/
            campaignService.getCampaignContacts = function (args, callback) {
                callback = (callback || angular.noop);
                var _campaignObject = null;

                function broadCastCampaignContactListResults(results, callback) {
                    // you can either send a callback or listen to the 'campaignSummaryResults' event.
                    $rootScope.$broadcast('campaignContactsListResults', results.data);
                    callback(results.data);
                }
                if (_campaignObject == null) {
                    _campaignObject = args || {};
                } else {
                    // enhance the object previously saved.
                    for (var property in args) {
                        _campaignObject[property] = args[property];
                    }
                }
                _campaignObject.page = (!!args && !!args.page && args.page > 0) ? args.page : 0;

                var _campaignId = $routeParams['ceid'] || _campaignObject['ceid'] || window.JV.CAMPAIGNEID;
                // ajax url.
                _campaignObject['url'] = CONST.Urls.contactsList.format(_campaignId);
                // ajaxtype for google analytics
                _campaignObject['ajaxtype'] = 'campaignContactsList';

                if (window.gdprEnabled === 'true') {
                    _campaignObject['anonymized'] = angular.isDefined(args) && args != null && angular.isDefined(args.anonymized) && args.anonymized != null && args.anonymized;
                }
                // Make a call to the backend and bind the promise with success.
                var _getCampaignContacts = makeAjaxCall(_campaignObject);
                _getCampaignContacts.then(function (results) {
                    // save the result in the cache.
                    broadCastCampaignContactListResults(results, callback);
                }, function(error){
                    $log.error(error.data);
                });
            };

            /*************************************************************
             * Save the contents of the newly created email template.
             *************************************************************/
            campaignService.saveEmailTemplate = function (args, callback) {
                callback = (callback || angular.noop);
                var _saveEmailTemplate = args || {};
                if (!!args.htmlMessage) {
                    var _htmlMessage = args.htmlMessage;
                    var tokens = _htmlMessage.match(/\[.*?\]/g); // Finds tokens between square  brackets
                    if (!!tokens) {
                        for (var i = 0; i < tokens.length; i++) {
                            _htmlMessage = _htmlMessage.split(tokens[i]).join(tokens[i].replace(/ /g, '-|-'));
                        }
                    }
                    args.htmlMessage = _htmlMessage;
                }

                function broadCastEmailTemplateSave(results, callback) {
                    $rootScope.$broadcast('emailTemplateSaved', results.data);
                    callback(results.data);
                }
                var _campaignId = $routeParams['ceid'] || _saveEmailTemplate['ceid'] || window.JV.CAMPAIGNEID;
                _saveEmailTemplate['url'] = CONST.Urls.saveEmailTemplate.format(_campaignId);
                _saveEmailTemplate['ajaxtype'] = 'saveEmailTemplate';
                _saveEmailTemplate['requestType'] = 'POST';

                var _saveEmailTemplateObj = makeAjaxCall(_saveEmailTemplate);
                _saveEmailTemplateObj.then(function (results) {
                    removeCacheWithKey('campaign_emails');
                    // save the result in the cache.
                    broadCastEmailTemplateSave(results, callback);
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.getReqTitleText = function (reqTitle, requisitionId) {
                if (reqTitle && requisitionId && requisitionId.trim() !== '') {
                    return reqTitle + ' (' + requisitionId.trim() + ')';
                }
                return reqTitle;
            };

            campaignService.copyEmailTemplate = function (args, callback) {
                callback = (callback || angular.noop);
                var _saveEmailTemplate = args || {};

                function broadCastEmailTemplateSave(results, callback) {
                    $rootScope.$broadcast('emailTemplateSaved', results.data);
                    callback(results.data);
                }
                var _campaignId = $routeParams['ceid'] || _saveEmailTemplate['ceid'] || JV.CAMPAIGNEID;
                _saveEmailTemplate['url'] = CONST.Urls.copyEmailTemplate.format(_campaignId, args.contentId);
                _saveEmailTemplate['ajaxtype'] = 'copyEmailTemplate';
                _saveEmailTemplate['requestType'] = 'POST';

                var _saveEmailTemplateObj = makeAjaxCall(_saveEmailTemplate);
                _saveEmailTemplateObj.then(function (results) {
                    removeCacheWithKey('campaign_emails');
                    // save the result in the cache.
                    broadCastEmailTemplateSave(results, callback);
                }, function(error){
                    $log.error(error.data);
                });
            };

            /*************************************************************
             * Get the email contents for this campaign. Use the cache here as we know when
             * the user adds or deletes or modifies the email template.
             *************************************************************/
            campaignService.getEmailContents = function (args, callback) {
                callback = (callback || angular.noop);
                var _emailContentsObj = args || {};
                var ifStripTemplate = !!args && !!args.stripContents;

                function broadCastEmailReceived(results, callback) {
                    //VA: for some reason it needs some time if the call is cached.
                    $timeout(function () {
                        $rootScope.$evalAsync(function (scope) {
                            var resultList = results.data.resultList;
                            var _results = [];
                            angular.forEach(resultList, function (value, index) {
                                if (!value.scheduleDate && value.status === 'IN_PROGRESS') {
                                    value.inProgress = true;
                                } else {
                                    value.inProgress = false;
                                }
                                _results.push(value);
                            });
                            results.data.resultList = _results;
                            scope.$broadcast('emailContentsReceived', results.data);
                            callback(results.data);
                        });
                    }, 1);
                }
                // check if the cache has the results.
                var _cache = getCacher('CAMPAIGN');
                var _results = _cache.get('campaign_emails');
                var _campaignId = $routeParams['ceid'] || _emailContentsObj['ceid'] || window.JV.CAMPAIGNEID;
                _emailContentsObj['url'] = CONST.Urls.getEmailContents.format(_campaignId);
                _emailContentsObj['ajaxtype'] = 'getEmailContents';

                var _getEmailContents = makeAjaxCall(_emailContentsObj);
                _getEmailContents.then(function (results) {
                    // save the result in the cache.
                    _cache.put('campaign_emails', results);
                    broadCastEmailReceived(results, callback);
                }, function(error){
                    $log.error(error.data);
                });
            };

            /*************************************************************
             * Delete the campaign email template with the given contentEid.
             * >>IMPORTANT: args should have the content resource eid 'contentEid'
             *************************************************************/
            campaignService.removeEmailTemplate = function (args, callback) {
                callback = (callback || angular.noop);
                var _emailContentsObj = args || {};
                if ($.trim(args.contentEid) === '') {
                    logService('missing resource eid');
                    return;
                }

                function broadCastEmailTemplateRemoved(results, callback) {
                    $rootScope.$broadcast('emailTemplateRemoved', results.data);
                    callback(results.data);
                }
                var _campaignId = $routeParams['ceid'] || _emailContentsObj['ceid'] || window.JV.CAMPAIGNEID;
                _emailContentsObj['url'] = CONST.Urls.deleteEmailTemplate.format(_campaignId, args.contentEid);
                delete args.contentEid
                _emailContentsObj['ajaxtype'] = 'removeEmailTemplate';
                _emailContentsObj['requestType'] = 'DELETE';
                var _removeEmailResource = makeAjaxCall(_emailContentsObj);
                _removeEmailResource.then(function (results) {
                    removeCacheWithKey('campaign_emails');
                    broadCastEmailTemplateRemoved(results, callback);
                }, function(error){
                    $log.error(error.data);
                });
            };

            /*************************************************************
             * Delete contacts from this campaign.
             * >>IMPORTANT: args should have an array of 'ids' of contacts.
             *************************************************************/
            campaignService.removeFromCampaign = function (args, callback) {
                callback = (callback || angular.noop);
                if (!args || !args.ids || args.ids.length < 1) {
                    logService('campaignService removeFromCampaign problem with the passed "ids" array object ');
                    return;
                }
                var _campaignObj = args;
                var _campaignId = $routeParams['ceid'] || _emailContentsObj['ceid'] || window.JV.CAMPAIGNEID;
                _campaignObj['url'] = CONST.Urls.removeFromCampaign;
                _campaignObj['ajaxtype'] = 'removeFromCampaign';
                _campaignObj['requestType'] = 'POST';
                _campaignObj['campaignIds'] = _campaignId;
                _campaignObj['action'] = 'doRemoveFromCampaign';
                var _removeFromCampaign = makeAjaxCall(_campaignObj);
                _removeFromCampaign.then(function (results) {
                    window.JV.showDropDownMessage(results.data);
                    callback(results.data);
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.getMessages = function (args, callback) {
                callback = (callback || angular.noop);
                var _messagesObj = args || {};

                function broadCastMessagesReceived(results, callback) {
                    $rootScope.$broadcast('messages', results.data);
                    callback(results.data);
                }
                var _campaignId = $routeParams['ceid'] || _messagesObj['ceid'] || window.JV.CAMPAIGNEID;
                _messagesObj['url'] = CONST.Urls.messagesList.format(_campaignId);
                _messagesObj['ajaxtype'] = 'messagesList';

                var _getMessagesContents = makeAjaxCall(_messagesObj);
                _getMessagesContents.then(function (results) {
                    broadCastMessagesReceived(results, callback);
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.scheduleCampaign = function (args, callback) {
                callback = (callback || angular.noop);
                var requestObj = args || {};
                requestObj.ajaxtype = 'scheduleCampaignAction';
                //requestObj.url = MODAL_CONST.actionUrls.scheduleCampaign.format( args.campaignEId, args.contentid );
                requestObj.url = CONST.Urls.scheduleCampaign.format(args.campaignEId, args.contentid);
                requestObj.requestType = 'POST';
                var _scheduleCampaign = makeAjaxCall(requestObj);
                _scheduleCampaign.then(function (results) {
                    // TODO: What to do after scheduling the campaign.
                    callback(results.data);
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.getAccounts = function (args, callback) {
                callback = (callback || angular.noop);
                var requestObj = args || {};
                requestObj.campaignEId = args['ceid'] || $routeParams['ceid'] || JV.CAMPAIGNEID;
                requestObj.ajaxtype = 'getAccounts';
                requestObj.url = CONST.Urls.socialAccounts.format(requestObj.campaignEId);
                requestObj.requestType = 'GET';
                var _getAccounts = makeAjaxCall(requestObj);
                _getAccounts.then(function (results) {
                    callback(results.data);
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.getFBAccounts = function (args, callback, failureCallback) {
                callback = (callback || angular.noop);
                failureCallback = (failureCallback || angular.noop);
                var requestObj = args || {};
                requestObj.campaignEId = args['ceid'] || $routeParams['ceid'] || window.JV.CAMPAIGNEID;
                requestObj.ajaxtype = 'getFBAccounts';
                requestObj.url = CONST.Urls.socialFBAccounts.format(requestObj.campaignEId);
                requestObj.requestType = 'GET';
                var _getAccounts = makeAjaxCall(requestObj);
                _getAccounts.then(function (results) {
                    if (results.data.error && results.data.error === 401) {
                        failureCallback();
                    } else {
                        callback(results.data);
                    }
                }, function (failure) {
                    if (failure.status === 303 || failure.status === 0) {
                        failureCallback();
                    }
                });
            };

            campaignService.sendAccessToken = function (args, callback) {
                callback = (callback || angular.noop);
                var requestObj = args || {};
                requestObj.campaignEId = args.campaignEId || $routeParams.ceid;
                requestObj.ajaxtype = 'getAccess';
                requestObj.url = CONST.Urls.sendAccessToken.format(requestObj.campaignEId, args.accessToken);
                requestObj.requestType = 'POST';
                var _getAccess = makeAjaxCall(requestObj);
                _getAccess.then(function (results) {
                    callback(results.data);
                }, function(error){
                    $log.error(error.data);
                });
            };

            var saveAccount = function (account, callback) {
                callback = (callback || angular.noop);
                var requestObj = {
                    name: account.name,
                    status: account.status,
                    platform: account.platform,
                    socialId: account.socialId
                };
                if (angular.isString(account.eid)) {
                    requestObj.eid = account.eid;
                }
                var campaignEId = $routeParams.ceid;
                requestObj.ajaxtype = 'saveAccount';
                requestObj.url = CONST.Urls.saveAccountsPage.format(campaignEId);
                requestObj.requestType = 'GET';
                var _saveAccount = makeAjaxCall(requestObj);
                _saveAccount.then(function (results) {
                    callback(results.data);
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.saveAccounts = function (args, callback) {
                callback = (callback || angular.noop);
                var counter = 0;
                var deferUntilEnd = $q.defer();
                deferUntilEnd.promise.then(function (data) {
                    callback(data);
                }, function(error){
                    $log.error(error.data);
                });
                angular.forEach(args.accounts, function (acct) {
                    saveAccount(acct, function (data) {
                        if (++counter === args.accounts.length) {
                            deferUntilEnd.resolve(data);
                        }
                    });
                });
            };

            campaignService.getDifferentCampaignDetails = function (args, callback) {
                callback = (callback || angular.noop);

                var _campaignObject = args || {};
                var _campaignId = _campaignObject['ceid'];

                if (angular.isUndefined(_campaignId)) {
                    // bad call, no campaign sought.
                    return;
                }
                _campaignObject.ajaxtype = 'campaignDetails';
                _campaignObject['url'] = CONST.Urls.details + _campaignId;

                var _getCampaignDetails = makeAjaxCall(_campaignObject);
                _getCampaignDetails.then(function (results) {
                    callback(results);
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.getTimeZone = function (args, callback) {
                callback = (callback || angular.noop);
                var requestObj = {};
                requestObj.ajaxtype = 'getTimeZoneCall';
                requestObj.url = window.jvUrls.source + '/action/sys/timezones';
                requestObj.requestType = 'GET';
                var _getTimeZone = makeAjaxCall(requestObj);
                _getTimeZone.then(function (results) {
                    callback(results.data);
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.republishError = function (args, callback) {
                callback = (callback || angular.noop);
                var requestObj = {};
                requestObj.ceid = args.ceid || $routeParams.ceid;
                requestObj.errorEId = args.errorEId;
                requestObj.ajaxtype = 'republishError';
                requestObj.url = CONST.Urls.republishError.format(requestObj.ceid, requestObj.errorEId);
                requestObj.requestType = 'GET';
                var _getRepublish = makeAjaxCall(requestObj);
                _getRepublish.then(function (results) {
                    if (results.status !== 200) {
                        //Some Error
                    } else {
                        callback(results);
                    }
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.getContactStatuses = function (args, callback) {
                callback = (callback || angular.noop);
                var requestObj = {};
                requestObj.action = requestObj.ajaxtype = 'getContactStatuses';
                requestObj.url = CONST.Urls.getContactStatuses;
                requestObj.requestType = 'GET';
                var _getContactStatuses = makeAjaxCall(requestObj);
                _getContactStatuses.then(function (results) {
                    callback(results);
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.getContactSources = function (args, callback) {
                callback = (callback || angular.noop);
                var requestObj = {};
                requestObj.action = requestObj.ajaxtype = 'getContactSources';
                requestObj.url = CONST.Urls.getContactSources;
                requestObj.requestType = 'GET';
                var _getContactSources = makeAjaxCall(requestObj);
                _getContactSources.then(function (results) {
                    callback(results);
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.checkOldCampaigns = function (args, callback) {
                callback = (callback || angular.noop);
                var requestObj = {};
                requestObj.ajaxtype = 'checkOldCampaigns';
                requestObj.url = CONST.Urls.checkOldCampaigns;
                requestObj.requestType = 'GET';
                var _checkOldCampaigns = makeAjaxCall(requestObj);
                _checkOldCampaigns.then(function (results) {
                    callback(results.data);
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.getPreviewMessage = function (args, callback) {
                callback = (callback || angular.noop);
                var requestObj = args || {};
                requestObj.ajaxtype = 'previewMessageClick';
                var _campaignId = $routeParams['ceid'] || _saveEmailTemplate['ceid'] || window.JV.CAMPAIGNEID;
                requestObj.url = CONST.Urls.previewCampaigns.format(_campaignId);
                requestObj.requestType = 'POST'; ///TODO: it should be post.
                var _previewCampaign = makeAjaxCall(requestObj);
                _previewCampaign.then(function (results) {
                    callback(results.data);
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.getRequisitionFilters = function (args, callback) {
                callback = (callback || angular.noop);
                var requestObj = {};
                requestObj.ajaxtype = 'getReqsFilters';
                requestObj.url = CONST.Urls.requisitionFilter;
                requestObj.requestType = 'GET';
                var _reqsFilter = makeAjaxCall(requestObj);
                _reqsFilter.then(function (results) {
                    callback(results.data);
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.cloneCampaign = function (args, callback) {
                callback = (callback || angular.noop);
                var requestObj = args || {};
                requestObj.ajaxtype = 'cloneCampaign';
                requestObj.url = CONST.Urls.clone;
                requestObj.requestType = 'POST';
                return makeAjaxCall(requestObj).then(function (results) {
                    callback(results.data);
                    return results.data;
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.getCustomFieldsList = function (callback) {
                callback = (callback || angular.noop);
                var requestObj = {
                    ajaxtype: 'getCustomFields',
                    url: CONST.Urls.customFieldsList,
                    requestType: 'GET'
                };
                return makeAjaxCall(requestObj).then(function (results) {
                    callback(results.data);
                    return results.data;
                }, function(error){
                    $log.error(error.data);
                });
            };

            campaignService.getTodayDateUserTimezone = function (timeZone) {
                var userTimeZone = (timeZone && timeZone.openSysId) ? timeZone.openSysId : window._jvselfUser.locale.timezone;
                var todayDate = new Date(moment.tz(new Date(), userTimeZone).format('MM/DD/YYYY'));
                return todayDate;
            };

            campaignService.getSelectedTimeZone = function (allTimeZones, openSysId) {
                for (var i = 0; i < allTimeZones.length; i++) {
                    if (openSysId === allTimeZones[i].openSysId) {
                        return allTimeZones[i];
                    }
                }
                return null;
            };
            return campaignService;
        }
    ]);